// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-pdf {
  width: 100%;
  min-height: 100vh;
  background: white;
  padding: 20px;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
}
.invoice-pdf .invoice-header,
.invoice-pdf .invoice-footer {
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}
.invoice-pdf .invoice-header {
  margin-bottom: 20px;
}
.invoice-pdf .invoice-footer {
  margin-top: auto;
  margin-bottom: 0;
}
.invoice-pdf .invoice-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.invoice-pdf .company-name {
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}
.invoice-pdf .invoice-details-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 30px;
  width: 100%;
}
.invoice-pdf .invoice-details-container .invoice-info,
.invoice-pdf .invoice-details-container .client-info {
  flex: 1 1;
  max-width: 50%;
}
.invoice-pdf .invoice-details-container .invoice-info h3,
.invoice-pdf .invoice-details-container .client-info h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  border-bottom: 2px solid #004A9A;
  padding-bottom: 5px;
  width: 100%;
}
.invoice-pdf .invoice-details-container .invoice-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 15px;
  margin-right: 0;
}
.invoice-pdf .invoice-details-container .client-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 15px;
  margin-left: 0;
  min-width: 0;
}
.invoice-pdf .invoice-details-container .client-info h3 {
  text-align: right;
}
.invoice-pdf .invoice-details-container .client-info p {
  width: 100%;
  word-wrap: break-word;
}
.invoice-pdf .invoice-info p,
.invoice-pdf .client-info p,
.invoice-pdf .bank-details p,
.invoice-pdf .terms p {
  margin: 4px 0;
  font-size: 14px;
}
.invoice-pdf .invoice-info p strong,
.invoice-pdf .client-info p strong,
.invoice-pdf .bank-details p strong,
.invoice-pdf .terms p strong {
  font-weight: bold;
}
.invoice-pdf .invoice-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: white;
}
.invoice-pdf .invoice-table th,
.invoice-pdf .invoice-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: left;
  vertical-align: top;
}
.invoice-pdf .invoice-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  font-size: 14px;
}
.invoice-pdf .invoice-table td {
  font-size: 13px;
}
.invoice-pdf .invoice-table th:nth-child(1),
.invoice-pdf .invoice-table td:nth-child(1) {
  width: 50%;
}
.invoice-pdf .invoice-table th:nth-child(2),
.invoice-pdf .invoice-table td:nth-child(2) {
  width: 15%;
  text-align: center;
}
.invoice-pdf .invoice-table th:nth-child(3),
.invoice-pdf .invoice-table td:nth-child(3) {
  width: 35%;
  text-align: right;
}
.invoice-pdf .breakdown-table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  background: white;
}
.invoice-pdf .breakdown-table td {
  border: 1px solid #000;
  padding: 8px;
  font-size: 13px;
  vertical-align: top;
}
.invoice-pdf .breakdown-table td:nth-child(1) {
  width: 50%;
}
.invoice-pdf .breakdown-table td:nth-child(2) {
  width: 15%;
  text-align: right;
  font-weight: normal;
}
.invoice-pdf .breakdown-table td:nth-child(3) {
  width: 35%;
  text-align: right;
  font-weight: normal;
}
.invoice-pdf .bank-details,
.invoice-pdf .terms {
  margin: 15px 0;
}
.invoice-pdf .bank-details strong,
.invoice-pdf .terms strong {
  display: block;
  margin-bottom: 5px;
  font-size: 16px;
}
.invoice-pdf .associated-cases {
  margin: 15px 0;
  page-break-inside: avoid;
}
.invoice-pdf .associated-cases > strong {
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
  border-bottom: 2px solid #004A9A;
  padding-bottom: 5px;
}
.invoice-pdf .associated-cases .case-type-section {
  margin-bottom: 15px;
}
.invoice-pdf .associated-cases .case-type-section:last-child {
  margin-bottom: 0;
}
.invoice-pdf .associated-cases .case-type-section .case-type-header {
  margin: 0 0 8px 0;
  font-weight: 600;
  font-size: 14px;
  color: #004A9A;
}
.invoice-pdf .associated-cases .case-type-section .case-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.invoice-pdf .associated-cases .case-type-section .case-list li {
  padding: 8px 12px;
  margin-bottom: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 13px;
}
.invoice-pdf .associated-cases .case-type-section .case-list li:last-child {
  margin-bottom: 0;
}
.invoice-pdf .associated-cases .case-type-section .case-list li .case-type-number {
  font-weight: 600;
  color: #1f2937;
}
.invoice-pdf .associated-cases .case-type-section .case-list li .party-names {
  color: #6b7280;
  font-size: 12px;
}
.invoice-pdf .signature {
  margin-top: 20px;
  text-align: right;
}
.invoice-pdf .signature img {
  width: 150px;
  margin-top: 10px;
  height: auto;
}
.invoice-pdf .signature p {
  margin: 10px 0 0 0;
  font-size: 12px;
  font-style: italic;
}
@media print {
  .invoice-pdf {
    width: 100%;
    margin: 0;
    padding: 20px;
  }
  .invoice-pdf .invoice-header,
  .invoice-pdf .invoice-footer {
    max-width: 100%;
    page-break-inside: avoid;
  }
  .invoice-pdf .invoice-table,
  .invoice-pdf .breakdown-table {
    page-break-inside: avoid;
  }
  .invoice-pdf .bank-details,
  .invoice-pdf .terms,
  .invoice-pdf .signature {
    page-break-inside: avoid;
  }
  .invoice-pdf .invoice-details-container {
    page-break-inside: avoid;
  }
}
@media (max-width: 768px) {
  .invoice-pdf .invoice-details-container {
    flex-direction: column;
    gap: 20px;
  }
  .invoice-pdf .invoice-details-container .invoice-info {
    padding-right: 0;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 15px;
  }
  .invoice-pdf .invoice-details-container .client-info {
    padding-left: 0;
    padding-top: 15px;
    text-align: left;
  }
  .invoice-pdf .invoice-details-container .client-info h3,
  .invoice-pdf .invoice-details-container .client-info p {
    text-align: left;
  }
}
.invoice-pdf * {
  box-sizing: border-box;
}
.invoice-pdf p,
.invoice-pdf div,
.invoice-pdf section {
  orphans: 2;
  widows: 2;
}
.invoice-pdf .invoice-info,
.invoice-pdf .client-info,
.invoice-pdf .bank-details,
.invoice-pdf .terms,
.invoice-pdf .signature {
  page-break-inside: avoid;
}

.req-pad {
  padding: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/InvoicePDFTemplate/InvoicePDFTemplate.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAEE;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,gBAAA;AAFJ;AAME;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAJJ;AAQE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AAUE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AARJ;AAUI;;EAEE,SAAA;EACA,cAAA;AARN;AAUM;;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;AAPR;AAWI;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAVN;AAYM;EACE,iBAAA;AAVR;AAaM;EACE,WAAA;EACA,qBAAA;AAXR;AAiBE;;;;EAIE,aAAA;EACA,eAAA;AAfJ;AAiBI;;;;EACE,iBAAA;AAZN;AAgBE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AAdJ;AAgBI;;EAEE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAdN;AAiBI;EACE,yBAAA;EACA,iBAAA;EACA,eAAA;AAfN;AAkBI;EACE,eAAA;AAhBN;AAmBI;;EAEE,UAAA;AAjBN;AAoBI;;EAEE,UAAA;EACA,kBAAA;AAlBN;AAqBI;;EAEE,UAAA;EACA,iBAAA;AAnBN;AAuBE;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AArBJ;AAuBI;EACE,sBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AArBN;AAyBI;EAEE,UAAA;AAxBN;AA2BI;EAEE,UAAA;EACA,iBAAA;EACA,mBAAA;AA1BN;AA6BI;EAEE,UAAA;EACA,iBAAA;EACA,mBAAA;AA5BN;AAgCE;;EAEE,cAAA;AA9BJ;AAgCI;;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AA7BN;AAkCE;EACE,cAAA;EACA,wBAAA;AAhCJ;AAkCI;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;AAhCN;AAmCI;EACE,mBAAA;AAjCN;AAmCM;EACE,gBAAA;AAjCR;AAoCM;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlCR;AAqCM;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AAnCR;AAqCQ;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAnCV;AAqCU;EACE,gBAAA;AAnCZ;AAsCU;EACE,gBAAA;EACA,cAAA;AApCZ;AAuCU;EACE,cAAA;EACA,eAAA;AArCZ;AA6CE;EACE,gBAAA;EACA,iBAAA;AA3CJ;AA6CI;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AA3CN;AA8CI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AA5CN;AAgDE;EAvRF;IAwRI,WAAA;IACA,SAAA;IACA,aAAA;EA7CF;EA+CE;;IAEE,eAAA;IACA,wBAAA;EA7CJ;EAgDE;;IAEE,wBAAA;EA9CJ;EAiDE;;;IAGE,wBAAA;EA/CJ;EAkDE;IACE,wBAAA;EAhDJ;AACF;AAoDE;EACE;IACE,sBAAA;IACA,SAAA;EAlDJ;EAoDI;IACE,gBAAA;IACA,gCAAA;IACA,oBAAA;EAlDN;EAqDI;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAnDN;EAqDM;;IAEE,gBAAA;EAnDR;AACF;AAyDE;EACE,sBAAA;AAvDJ;AA0DE;;;EAGE,UAAA;EACA,SAAA;AAxDJ;AA4DE;;;;;EAKE,wBAAA;AA1DJ;;AA8DA;EACE,eAAA;AA3DF","sourcesContent":[".invoice-pdf {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  background: white;\r\n  padding: 20px;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  color: #333;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // Header and Footer images\r\n  .invoice-header,\r\n  .invoice-footer {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 150px;\r\n    object-fit: contain;\r\n    display: block;\r\n    flex-shrink: 0; // Prevent shrinking\r\n  }\r\n\r\n  .invoice-header {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .invoice-footer {\r\n    margin-top: auto; // Push to bottom\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  // Content wrapper to ensure proper spacing\r\n  .invoice-content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 0; // Allow shrinking if needed\r\n  }\r\n\r\n  // Company name style\r\n  .company-name {\r\n    font-size: 28px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  // Two-column layout for invoice details and client info\r\n  .invoice-details-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-bottom: 20px;\r\n    gap: 30px;\r\n    width: 100%;\r\n\r\n    .invoice-info,\r\n    .client-info {\r\n      flex: 1;\r\n      max-width: 50%;\r\n\r\n      h3 {\r\n        font-size: 16px;\r\n        font-weight: bold;\r\n        margin-bottom: 10px;\r\n        color: #333;\r\n        border-bottom: 2px solid #004A9A;\r\n        padding-bottom: 5px;\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .invoice-info {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: flex-start;\r\n      align-items: flex-start;\r\n      padding-right: 15px;\r\n      margin-right: 0;\r\n    }\r\n\r\n    .client-info {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: flex-start;\r\n      align-items: flex-start; // CHANGE FROM flex-end to flex-start\r\n      padding-left: 15px;\r\n      margin-left: 0;\r\n      min-width: 0;\r\n\r\n      h3 {\r\n        text-align: right;\r\n      }\r\n\r\n      p {\r\n        width: 100%;\r\n        word-wrap: break-word;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Paragraph styles\r\n  .invoice-info p,\r\n  .client-info p,\r\n  .bank-details p,\r\n  .terms p {\r\n    margin: 4px 0;\r\n    font-size: 14px;\r\n\r\n    strong {\r\n      font-weight: bold;\r\n    }\r\n  }\r\n\r\n  .invoice-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin: 20px 0;\r\n    background: white;\r\n\r\n    th,\r\n    td {\r\n      border: 1px solid #000;\r\n      padding: 8px;\r\n      text-align: left;\r\n      vertical-align: top;\r\n    }\r\n\r\n    th {\r\n      background-color: #f5f5f5;\r\n      font-weight: bold;\r\n      font-size: 14px;\r\n    }\r\n\r\n    td {\r\n      font-size: 13px;\r\n    }\r\n\r\n    th:nth-child(1),\r\n    td:nth-child(1) {\r\n      width: 50%;\r\n    }\r\n\r\n    th:nth-child(2),\r\n    td:nth-child(2) {\r\n      width: 15%;\r\n      text-align: center;\r\n    }\r\n\r\n    th:nth-child(3),\r\n    td:nth-child(3) {\r\n      width: 35%;\r\n      text-align: right;\r\n    }\r\n  }\r\n\r\n  .breakdown-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin: 10px 0;\r\n    background: white;\r\n\r\n    td {\r\n      border: 1px solid #000;\r\n      padding: 8px;\r\n      font-size: 13px;\r\n      vertical-align: top;\r\n    }\r\n\r\n    // Column width matching main table\r\n    td:nth-child(1) {\r\n      // Empty column to match Description\r\n      width: 50%;\r\n    }\r\n\r\n    td:nth-child(2) {\r\n      // Label column\r\n      width: 15%;\r\n      text-align: right;\r\n      font-weight: normal;\r\n    }\r\n\r\n    td:nth-child(3) {\r\n      // Amount column\r\n      width: 35%;\r\n      text-align: right;\r\n      font-weight: normal;\r\n    }\r\n  }\r\n\r\n  .bank-details,\r\n  .terms {\r\n    margin: 15px 0;\r\n\r\n    strong {\r\n      display: block;\r\n      margin-bottom: 5px;\r\n      font-size: 16px;\r\n    }\r\n  }\r\n\r\n  // Associated Cases Section\r\n  .associated-cases {\r\n    margin: 15px 0;\r\n    page-break-inside: avoid;\r\n\r\n    > strong {\r\n      display: block;\r\n      margin-bottom: 10px;\r\n      font-size: 16px;\r\n      color: #333;\r\n      border-bottom: 2px solid #004A9A;\r\n      padding-bottom: 5px;\r\n    }\r\n\r\n    .case-type-section {\r\n      margin-bottom: 15px;\r\n\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      .case-type-header {\r\n        margin: 0 0 8px 0;\r\n        font-weight: 600;\r\n        font-size: 14px;\r\n        color: #004A9A;\r\n      }\r\n\r\n      .case-list {\r\n        list-style: none;\r\n        padding: 0;\r\n        margin: 0;\r\n\r\n        li {\r\n          padding: 8px 12px;\r\n          margin-bottom: 6px;\r\n          background: #f8fafc;\r\n          border: 1px solid #e2e8f0;\r\n          border-radius: 4px;\r\n          font-size: 13px;\r\n\r\n          &:last-child {\r\n            margin-bottom: 0;\r\n          }\r\n\r\n          .case-type-number {\r\n            font-weight: 600;\r\n            color: #1f2937;\r\n          }\r\n\r\n          .party-names {\r\n            color: #6b7280;\r\n            font-size: 12px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Signature style\r\n  .signature {\r\n    margin-top: 20px;\r\n    text-align: right;\r\n\r\n    img {\r\n      width: 150px;\r\n      margin-top: 10px;\r\n      height: auto;\r\n    }\r\n\r\n    p {\r\n      margin: 10px 0 0 0;\r\n      font-size: 12px;\r\n      font-style: italic;\r\n    }\r\n  }\r\n\r\n  @media print {\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 20px;\r\n\r\n    .invoice-header,\r\n    .invoice-footer {\r\n      max-width: 100%;\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    .invoice-table,\r\n    .breakdown-table {\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    .bank-details,\r\n    .terms,\r\n    .signature {\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    .invoice-details-container {\r\n      page-break-inside: avoid;\r\n    }\r\n  }\r\n\r\n  // Responsive design for smaller screens\r\n  @media (max-width: 768px) {\r\n    .invoice-details-container {\r\n      flex-direction: column;\r\n      gap: 20px;\r\n\r\n      .invoice-info {\r\n        padding-right: 0;\r\n        border-bottom: 1px solid #e0e0e0;\r\n        padding-bottom: 15px;\r\n      }\r\n\r\n      .client-info {\r\n        padding-left: 0;\r\n        padding-top: 15px;\r\n        text-align: left; // Reset alignment on mobile\r\n\r\n        h3,\r\n        p {\r\n          text-align: left;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Ensure proper spacing and avoid orphans\r\n  * {\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  p,\r\n  div,\r\n  section {\r\n    orphans: 2;\r\n    widows: 2;\r\n  }\r\n\r\n  // Force content to stay together when possible\r\n  .invoice-info,\r\n  .client-info,\r\n  .bank-details,\r\n  .terms,\r\n  .signature {\r\n    page-break-inside: avoid;\r\n  }\r\n}\r\n\r\n.req-pad {\r\n  padding: 0.8rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
